import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { STORAGE_KEYS } from '@/constants/config';
import ru from './ru.json';
import kk from './kk.json';

// Source of truth for locale keys is `source/mobile/src/locales/*.json`.
// Web-specific keys live under `web.*` (navigation, desktop hints, etc.).
//
// Detection order:
//   1. localStorage[monthly.locale] — explicit user choice
//   2. navigator.language
//   3. fallback to 'ru'

export const SUPPORTED_LOCALES = ['ru', 'kk'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      kk: { translation: kk },
    },
    fallbackLng: 'ru',
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEYS.locale,
      caches: ['localStorage'],
    },
  });

export function setLocale(locale: SupportedLocale): void {
  void i18n.changeLanguage(locale);
  try {
    localStorage.setItem(STORAGE_KEYS.locale, locale);
  } catch {
    // localStorage may be unavailable in private mode — ignore silently.
  }
}

export default i18n;
